<template lang="pug">
div.right-column
  div.home.column(@click='goHome')
    //- i.icon-homePage.iconfont
    img.iconfont(src='../../assets/doCase/homePage.png')
  div.search.column(@click='openSearchModal')
    //- i.icon-sousuo-copy.iconfont
    img.iconfont(src='../../assets/doCase/sousuo-copy.png')
  div.Unknown.column(@click='openAnalyzeModal')
    //- i.icon-kaoshi.iconfont
    img.iconfont(src='../../assets/doCase/kaoshi.png')
  div.Unknown.column(@click='openNoteModal')
    //- i.icon-kaoshi.iconfont
    img.iconfont(src='../../assets/doCase/biji.png')
  Drawer(@close="openNoteModal" :align="align" :closeable="true", :mask='false' style="z-index:200000" :zIndex='200000')
    .note(v-if="open")
      .title
        img(src='../../assets/doCase/biji.png')
        p 笔记
      Input(placeholder="你可以记录与案例有关的内容～",type="textarea", show-word-limit, autofocus,:maxlength="8000",@on-change="save_note",
        v-model="content")
</template>
<script>
import { findBrothersComponents } from "@/utils/assist.js";
import Drawer from "vue-simple-drawer";

export default {
  components: {
    Drawer
  },
  props: {
    experimentId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      open: false,
      innerOpen: false,
      align: "left",
      outTime: null,
      content: ""
    };
  },
  created() {
    this.query();
  },
  methods: {
    query() {
      this.$http.getNote({
          experimentId: this.experimentId
      }).then(res => {
        this.content = res.data.data ?? "";
      });
    },
    save_note() {
      // 简单写个防抖
      if (this.outTime !== null) {
        clearTimeout(this.outTime);
        this.outTime = null;
      }
      this.outTime = setTimeout(() => {
        clearTimeout(this.outTime);
        this.outTime = null;
        const data = {
          experimentId: this.experimentId,
          content: this.content
        };
        this.$http.saveNote(data).then(res => {
          console.log(res);
        });
      }, 1000);
    },
    openNoteModal() {
      this.open = !this.open;
    },
    goHome() {
      this.$emit("goHome");
    },
    openSearchModal() {
      const searchModal = findBrothersComponents(this, "searchModal", false);
      searchModal[0].searchModal = true;
    },
    openAnalyzeModal() {
      const analyzeModal = findBrothersComponents(this, "analyzeModal", false);
      analyzeModal[0].analyzeModal = true;
    }
  }
};
</script>

<style lang="stylus" scoped>
.right-column
  position fixed
  height 220px
  width 48px
  top 0
  z-index 40000
  bottom 0
  margin auto
  right 24px
  display flex
  flex-flow column
  justify-content space-between
  >>>.vue-simple-drawer
    padding: 0!important;
    .close-btn
      .leftright,.rightleft
        background-color:#9B9B9B
.home
  min-width initial
  min-height initial
.note
  width: 20vw;
  height: 100vh;
  background: #FFFFFF;
  box-shadow: 1px 0px 4px 0px rgba(0, 0, 0, 0.2);
  padding: 32px 34px!important;
  font-size: 16px;
  font-family: MicrosoftYaHeiUI-Bold, MicrosoftYaHeiUI;
  font-weight: bold;
  color: rgba(42, 46, 54, 0.8);
  .title
    display: flex;
    align-items center
    img
      height: 16px;
      margin-right 24px
  >>>.ivu-input-type-textarea
    width: 100%;
    height: calc(100% - 24px);
    border none;
    outline none;
    resize: none;
    margin-top 24px
    textarea
      width: 100%;
      height: calc(100% - 24px);
      border none;
      outline none;
      resize: none;
.column
  width 48px
  height 48px
  background #ffffff
  box-shadow 0px 0px 4px 0px rgba(210, 221, 236, 1)
  border-radius 8px
  cursor pointer
  .iconfont
    height 22px
    margin-top 13px
    // font-size 22px
    // color #2A2E36
    // line-height 48px
</style>
